// helper to import all images in folder
function importAll(r) {
  let images = {};
  r.keys().forEach((key) => {
    const name = key.replace("./", "");
    images[name] = r(key);
  });
  return images;
}

// import everything from gallery folder
const Images = importAll(
  require.context("../gallery", false, /\.(png|jpe?g|svg)$/)
);

export const galleryItems = [
  { id: 1, category: "Events", image: Images["image1.jpg"], includeInPreview: true },
  { id: 2, category: "School", image: Images["image2.jpg"], includeInPreview: true},
  { id: 3, category: "Infrastructure", image: Images["image44.jpg"], priority: "high"  },
  { id: 4, category: "School", image: Images["image4.jpg"], includeInPreview: true },
  { id: 5, category: "Events", image: Images["image5.jpg"], includeInPreview: true },
  { id: 6, category: "School", image: Images["image6.jpg"] },
  { id: 7, category: "Events", image: Images["image7.jpg"] },
  { id: 8, category: "Events", image: Images["image8.jpg"] },
  { id: 9, category: "Events", image: Images["image9.jpg"] },
  { id: 10, category: "School", image: Images["image10.jpg"] },
  { id: 11, category: "Events", image: Images["image11.jpg"] },
  { id: 12, category: "Events", image: Images["image12.jpg"] },
  { id: 13, category: "Events", image: Images["image13.jpg"] },
  { id: 14, category: "Events", image: Images["image14.jpg"] },
  { id: 15, category: "Events", image: Images["image15.jpg"] },
  { id: 16, category: "School", image: Images["image16.jpg"], priority: "high" },
  { id: 17, category: "School", image: Images["image17.jpg"], priority: "high" },
  { id: 18, category: "School", image: Images["image18.jpg"] },
  { id: 19, category: "School", image: Images["image19.jpg"] },
  { id: 20, category: "School", image: Images["image20.jpg"], priority: "high" },
  { id: 21, category: "School", image: Images["image21.jpg"] },
  { id: 22, category: "Events", image: Images["image22.jpg"] },
  { id: 23, category: "Events", image: Images["image23.jpg"] },
  { id: 24, category: "Events", image: Images["image24.jpg"] },
  { id: 25, category: "Events", image: Images["image25.jpg"] },
  { id: 26, category: "School", image: Images["image26.jpg"] },
  { id: 27, category: "School", image: Images["image27.jpg"] },
  { id: 28, category: "School", image: Images["image28.jpg"] },
  { id: 29, category: "School", image: Images["image29.jpg"] },
  { id: 30, category: "Sports", image: Images["image30.jpg"], priority: "high" },
  { id: 31, category: "School", image: Images["image31.jpg"] },
  { id: 32, category: "School", image: Images["image32.jpg"] },
  { id: 33, category: "School", image: Images["image33.jpg"] },
  { id: 34, category: "School", image: Images["image34.jpg"] },
  { id: 35, category: "School", image: Images["image35.jpg"] },
  { id: 36, category: "School", image: Images["image36.jpg"] },
  { id: 37, category: "School", image: Images["image37.jpg"] },
  { id: 38, category: "School", image: Images["image38.jpg"] },
  { id: 39, category: "School", image: Images["image39.jpg"] },
  { id: 40, category: "Community Outreach", image: Images["image40.jpg"] },
  { id: 41, category: "Sports", image: Images["image41.jpg"] },
  { id: 42, category: "Community Outreach", image: Images["image42.jpg"] },
  { id: 43, category: "Infrastructure", image: Images["image45.jpg"], priority: "high"  },
  { id: 44, category: "Infrastructure", image: Images["image43.jpg"], priority: "high"  },
];

